import { Grid, Modal } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import {
  Button,
  FileDropZone,
  TypableDropdown,
} from '@HomaHealth/ui-component-library/lib/_AIQ-components';
import { Typography } from '@HomaHealth/ui-component-library/lib/_patient-access-components';

import { patientAccessTheme } from '@HomaHealth/ui-component-library/lib/theme/theme';
import React, { useState } from 'react';
import componentConstants from '../../../core-utils/messages/componentConstants';
import ReportCreateNewLabelField from '../../atoms/ReportCreateNewLabelField';

export const cellStyles4 = {
  color: patientAccessTheme.palette.text.mediumemphasis,
  fontSize: '14px',
  fontWeight: 400,
};

export interface AddCareNavGroupModalProps {
  open: boolean;
  handleClose: () => any;
  handleSave: () => any;
  groupValueState: [any, React.Dispatch<React.SetStateAction<any>>];
  isSaveButtonDisabled: boolean;
  groupNames: any[];
}

const AddCareNavGroupModal: React.FC<AddCareNavGroupModalProps> = ({
  open,
  handleClose,
  handleSave,
  groupValueState,
  isSaveButtonDisabled,
  groupNames,
}) => {
  const constants = componentConstants.ORGANISMS.CARE_NAV_MODALS.ADD_GROUP;

  const [groupValue, setGroupValue] = groupValueState;
  const [groupName, setGroupName] = useState<string>('');
  const [uploadedFile, setUploadedFile] = useState<any>(null);

  const useStyles = makeStyles()({
    modal: {
      width: '553px',
      height: groupValue?.employer_id ? '300px' : '568px',
      background: patientAccessTheme.palette.status.white,
      borderRadius: '8px',
      padding: '24px 24px 24px 24px',
      position: 'absolute',
      top: '50%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      flexDirection: 'column',
    },
    inputFieldsGrid: {
      width: '505px',
      margin: '20px 0px',
      background: '#FBFBFE',
      padding: '24px 24px 14px 24px',
      borderRadius: '8px',
    },
    selectFields: {
      display: 'flex',
      flexDirection: 'row',
      marginBottom: '10px',
    },
    cancelButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border: '1px solid ' + patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
    saveButton: {
      padding: '9px 16px',
      width: '102px',
      height: '36px',
      border:
        '1px solid ' + isSaveButtonDisabled
          ? patientAccessTheme.palette.grey[500]
          : patientAccessTheme.palette.primary[500],
      borderRadius: '4px',
      textTransform: 'none',
      fontSize: '12px',
      lineHeight: '12px',
      fontWeight: 500,
    },
  });

  const { classes } = useStyles();

  return (
    <Modal open={open} onClose={handleClose}>
      <Grid container className={classes.modal}>
        <Grid>
          <Typography
            fontSize="18px"
            lineHeight="26px"
            fontType="semibold"
            textColor={patientAccessTheme.palette.text.highemphasis}
            margin="4px 0px 0px 0px"
          >
            {constants.TITLE}
          </Typography>
          <Typography
            fontSize="14px"
            lineHeight="24px"
            fontType="normal"
            textColor={patientAccessTheme.palette.text.mediumemphasis}
            margin="4px 0px 5px 0px"
          >
            {constants.SUB_TITLE}
          </Typography>
        </Grid>

        <Grid container className={classes.inputFieldsGrid}>
          <Grid>
            <ReportCreateNewLabelField
              label={constants.GROUP}
              required
              component={
                <TypableDropdown
                  dropDownOptions={groupNames.map((item) => item.employer_name)}
                  dropDownValues={groupNames.map((item) => item.employer_id)}
                  placeholder={constants.GROUP_LABEL}
                  value={groupName}
                  handleChange={(event) => {
                    const value = event?.target?.value as string;
                    setGroupValue({
                      employer_id: value,
                      employer_name: groupNames.find(
                        (item) => item.employer_id === value,
                      )?.employer_name,
                    });
                    setGroupName(value);
                  }}
                  handleInputChange={(value) => {
                    setGroupName(value);
                    setGroupValue({
                      employer_id: '',
                      employer_name: value,
                    });
                  }}
                  disabled={false}
                  textFieldPlaceholder="Enter group name here (or) select from below"
                  height="36px"
                  width="455px"
                />
              }
            />
          </Grid>
        </Grid>

        {!groupValue.employer_id && (
          <Grid>
            <FileDropZone
              filesSupported={['CSV']}
              uploadedFiles={uploadedFile}
              setUploadedFiles={setUploadedFile}
            />
          </Grid>
        )}

        <Grid
          container
          style={{
            position: 'absolute',
            bottom: 0,
            margin: '0px 0px 24px 240px',
          }}
          sx={{
            alignItems: 'center',
          }}
        >
          <Grid style={{ marginRight: '12px' }}>
            <Button
              label={constants.CANCEL}
              variant="outlined"
              className={classes.cancelButton}
              onClick={handleClose}
            />
          </Grid>
          <Grid>
            <Button
              label={constants.SUBMIT}
              variant="contained"
              className={classes.saveButton}
              disabled={isSaveButtonDisabled}
              onClick={() => {
                handleSave && handleSave();
              }}
            />
          </Grid>
        </Grid>
      </Grid>
    </Modal>
  );
};
export default AddCareNavGroupModal;
